import {getValue} from '@/utils/PathAccessor';

export function accessor (object, path, defaultValue = undefined) {
  return getValue(object, path, defaultValue);
}
